<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-08-22 16:33:05
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Roster\RosterRecord\components\RecalculateDialog.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-05-23 10:46:25
-->
<template>
  <normalDialog
    :dialog="show"
    width="680"
    :title="$t('label_essweb_RosterRecord_dialog_reCalreGeTitle')"
    maxWidth="680"
    @close="closeDialog"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <AutoComplete
              v-model="selectStaff"
              :items="curStaffs"
              label="label_essweb_RosterRecord_dialog_staffLabel"
              chips
              :filter="$staffFilter"
              hide-details
              deletable-chips
              multiple
              two-line
              avatar
              item-text="staff_code"
              item-value="staff_id"
            >
              <template v-slot:selection.avatar="{ data }">
                <StaffAvatar
                  size="36"
                  left
                  contentClass="white--text"
                  :src="data.item.staff_avatar"
                  :staff_name="data.item.preferred_name"
                />
              </template>
              <template v-slot:selection="{ data }">
                {{ $getCommonLangValue(data.item.preferred_name) }}
              </template>
              <template v-slot:item.avatar="{ data }">
                <StaffAvatar
                  size="36"
                  :src="data.item.staff_avatar"
                  :staff_name="data.item.preferred_name"
                />
              </template>
              <template v-slot:item.title="{ data }">
                <span class="text-body-2"
                  >{{ $getCommonLangValue(data.item.preferred_name) }}
                  <span class="text--secondary text-caption-xs">{{
                    data.item.staff_code
                  }}</span></span
                >
              </template>
              <template v-slot:item.subtitle="{ data }">
                {{ $getCommonLangValue(data.item.job_post_name) }}
              </template>
            </AutoComplete>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <DateTimePicker
              isRequire
              type="daterange"
              :value="curtime"
              :placeholder="$t('label_essweb_RosterRecord_list_seTimeLabel')"
              :defaultStartTime="defaultStartDate"
              :defaultEndTime="defaultEndDate"
              :label="$t('label_essweb_RosterRecord_dialog_dateLabel')"
              @change="
                (time, isre) => {
                  curtime = time;
                  if (isre) {
                    defaultStartDate = time ? time.split(' - ')[0] : '';
                    defaultEndDate = time ? time.split(' - ')[1] : '';
                  }
                }
              "
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <CardActions
        submitBtn
        @submit="toSave"
        :onLoading="isLoading"
        @cancel="closeDialog"
      />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "RecalculateDialog",
  computed: {
    ...mapGetters(["isLoading"]),
  },
  props: {
    show: { default: false, type: Boolean },
    // curStaffs: { default: [], type: Array },
  },
  data() {
    return {
      selectStaff: [],
      curStaffs: [],
      curtime: { start: "", end: "", value: "" },
      defaultStartDate: "",
      defaultEndDate: "",
    };
  },
  watch: {
    show(val) {
      if (val) {
        if (this.$refs["form"]) this.$refs["form"].reset();
        this.curtime = { start: "", end: "", value: "" };
        this.defaultStartDate = "";
        this.defaultEndDate = "";
      }
    },
  },
  created() {
    this.$getStaffList().then((res) => {
      this.curStaffs = res;
    });
  },
  methods: {
    closeDialog: function () {
      this.$emit("close");
    },
    removeStaff: function (item) {
      const index = this.selectStaff.indexOf(item.staff_id); //2020-10-20 staff_id-->user_id//2021-11-20 user_id--staff_id
      if (index >= 0) this.selectStaff.splice(index, 1);
    },
    toSave: function () {
      if (this.selectStaff.length <= 0) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_selectAgain"),
          text: this.$t(
            "message_essweb_rosterFormRecord_form_selectStaffLabel"
          ),
          type: "warning",
        });
        return false;
      }
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$emit(
        "onSave",
        this.selectStaff,
        this.defaultStartDate,
        this.defaultEndDate
      );
    },
  },
};
</script>
